import React, { useEffect, useRef } from 'react';

export default function CustomCursor() {
  const cursorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.innerWidth <= 1024) return;

    const cursor = cursorRef.current;
    if (!cursor) return;

    let visible = false;

    const onMouseMove = (e: MouseEvent) => {
      // Direct DOM manipulation — zero React re-renders
      cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -50%)`;
      if (!visible) {
        cursor.style.opacity = '1';
        visible = true;
      }
    };

    const onMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target || typeof target.closest !== 'function') return;
      const isClickable =
        target.closest('a, button, [role="button"], .cursor-pointer');

      if (isClickable) {
        cursor.style.width = '2.5rem';
        cursor.style.height = '2.5rem';
      } else {
        cursor.style.width = '1rem';
        cursor.style.height = '1rem';
      }
    };

    const onMouseLeave = () => {
      cursor.style.opacity = '0';
      visible = false;
    };

    const onMouseEnter = () => {
      cursor.style.opacity = '1';
      visible = true;
    };

    document.addEventListener('mousemove', onMouseMove, { passive: true });
    document.addEventListener('mouseover', onMouseOver, { passive: true });
    document.documentElement.addEventListener('mouseleave', onMouseLeave);
    document.documentElement.addEventListener('mouseenter', onMouseEnter);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseover', onMouseOver);
      document.documentElement.removeEventListener('mouseleave', onMouseLeave);
      document.documentElement.removeEventListener('mouseenter', onMouseEnter);
    };
  }, []); // Empty deps — never re-registers listeners

  if (typeof window !== 'undefined' && window.innerWidth <= 1024) return null;

  return (
    <div
      ref={cursorRef}
      className="fixed top-0 left-0 rounded-full pointer-events-none z-[10000] mix-blend-difference bg-white"
      style={{
        width: '1rem',
        height: '1rem',
        opacity: 0,
        transition: 'width 0.2s ease-out, height 0.2s ease-out, opacity 0.2s ease-out',
        willChange: 'transform',
      }}
    />
  );
}
